// Shared Tailwind class constants for the settlement list/form views.

// Flat Ocean: the approved pairing is Ivory on Ocean, so white text stays legible.
export const settlementCardClasses =
    'bg-primary rounded-md ' +
    'px-2.5 py-3.5 text-white flex flex-col items-center ' +
    'justify-start h-full min-h-35 border-b border-border-light ' +
    'last:border-b-0 ' +
    '[&_small]:text-xs [&_small]:text-white [&_small]:block';

export const settlementTextClasses =
    'text-xs! text-white text-center block';

export const settlementsContainerClasses =
    'bg-white rounded-b-lg overflow-hidden';

// Header and row share the same six-column grid layout.
const settlementGridClasses =
    'grid [grid-template-columns:2fr_1.5fr_1.5fr_1.5fr_1.5fr_160px] items-center';

// Stone header, no rule beneath it: the rows' own dividers carry the structure.
export const settlementsHeaderClasses =
    `${settlementGridClasses} items-end! p-1.5 gap-5 bg-table-header`;

export const settlementRowBaseClasses =
    `${settlementGridClasses} px-1.5 py-4 gap-5 bg-white`;

export const settlementRowActiveBg = 'bg-primary-surface';

export const settlementColClasses = 'min-w-0';

export const settlementActionColClasses =
    `${settlementColClasses} flex-[0_0_auto] ml-auto`;

// Rows are separated by the neutral hairline; the last row's bottom edge closes the
// whole section, which the design draws in the warmer Sand rule instead.
export const settlementWrapperClasses =
    'bg-white p-1.5 border-b border-border last:border-b-border-accent';

export const settlementWrapperActiveBg = 'bg-primary-surface';

export const settlementDetailsSectionClasses =
    'bg-surface p-4';

export const settlementDetailsTitleClasses =
    'text-2xl font-semibold text-content mb-6';

export const settlementFormColClasses = 'flex-1';

// `items-end` keeps the Done button at its natural height (aligned to the
// bottom of the cell) instead of stretching to the grid row height.
export const doneColClasses = 'flex-[0.5] flex justify-end items-end';

export const settlementHeaderColClasses =
    'flex-1 font-semibold text-body text-base min-w-0';

// Per-row "stack" label shown only on narrow viewports (currently hidden).
export const settlementColHeaderClasses =
    'hidden font-semibold text-body text-sm mb-2 uppercase tracking-[calc(var(--spacing)*0.125)]';

export const settlementPlaintiffInfoClasses =
    'flex items-center gap-4';

export const settlementPlaintiffDetailsClasses =
    '[&_h5]:m-0 [&_h5]:text-base [&_h5]:font-bold [&_h5]:text-content ' +
    '[&_p]:mt-0.5 [&_p]:mb-0 [&_p]:mx-0 [&_p]:text-base [&_p]:text-disabled [&_p]:font-normal';

export const settlementAmountTextClasses =
    'text-base font-normal text-content';

export const settlementAmountFinalClasses =
    'text-base font-bold text-success';

export const settlementStatusPendingClasses =
    'text-disabled italic text-base';
